module.exports = __webpack_public_path__ + "static/img/shouye3.22092c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/shouye3.png
// module id = Nf8r
// module chunks = 17